import Scrolling from '../utils/class/scrolling';

const QUERIES = {
    popup: '.site-popup',
    toggle: '.site-popup-toggle',
    close: '.site-popup-close',
    window: '.site-popup-window'
};

export default class Popup {
    constructor(queries = QUERIES) {
        const popup = queries.popup ? document.querySelector(queries.popup) : document.querySelector(QUERIES.popup);
        if (!popup) throw new Error('Popup not found');

        const toggles = queries.toggle ? document.querySelectorAll(queries.toggle) : document.querySelectorAll(QUERIES.toggle);
        const close = queries.close ? document.querySelector(queries.close) : document.querySelector(QUERIES.close);
        const inner = queries.window ? document.querySelector(queries.window) : document.querySelector(QUERIES.window);

        this.popup = popup;
        this.toggles = [...toggles];
        this.closeBtn = close || null;
        this.inner = inner || null;
        this.scrolling = new Scrolling();

        this.init();
    }

    init() {
        if (this.toggles.length) {
            this.toggles.forEach((toggle) => {
                toggle.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    this.handleOpen();
                });
            });
        }

        if (this.popup) {
            this.popup.addEventListener('click', () => {
                this.handleClose();
            });
        }

        if (this.inner) {
            this.inner.addEventListener('click', (event) => {
                event.stopPropagation();
            });
        }

        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                this.handleClose();
            });
        }
    }

    handleOpen() {
        this.scrolling.disable();
        this.popup.classList.add('opened');
    }

    handleClose() {
        this.scrolling.enable();
        this.popup.classList.remove('opened');
    }

    open() {
        this.handleOpen();
    }

    close() {
        this.handleClose();
    }
}